<nav class="ariane-nav" aria-label="breadcrumb">
  <ol class="ariane-list">
    
    <li class="ariane-item home">
      <a [routerLink]="route.get('home')" title="Accueil">
        <i class="fa-solid fa-house"></i>
      </a>
    </li>

    <li *ngIf="categ" class="ariane-item">
      <a [routerLink]="route.parse('products-list', ['categ', categ.ident, categ.name])">
        {{categ.name}}
      </a>
    </li>

    <li *ngIf="scateg" class="ariane-item">
      <a [routerLink]="route.parse('products-list', ['scateg', scateg.ident, scateg.name])">
        {{scateg.name}}
      </a>
    </li>

    <li *ngIf="gamme" class="ariane-item">
      <a [routerLink]="route.parse('products-list', ['gamme', gamme.ident, gamme.name])">
        {{gamme.name}}
      </a>
    </li>

    <li *ngIf="marque" class="ariane-item">
      <a [routerLink]="route.parse('products-list', ['marque', marque.ident, marque.name])">
        {{marque.name}}
      </a>
    </li>

  </ol>
</nav>